export const SEARCH_API_PATHS = {
  products: '/search/products',
} as const

export const SEARCH_PATHS = {
  /** React Router path segment (no leading slash). */
  route: 'search',
  page: '/search',
} as const

export const SEARCH_SORT_BY = {
  relevance: 'relevance',
  createdAt: 'createdAt',
  displayPrice: 'displayPrice',
  name: 'name',
} as const

export const SEARCH_SORT_ORDER = {
  asc: 'asc',
  desc: 'desc',
} as const

export const SEARCH_DEFAULTS = {
  page: 1,
  limit: 20,
  suggestionLimit: 8,
  minQueryLength: 1,
  debounceMs: 350,
  sortBy: SEARCH_SORT_BY.relevance,
  sortOrder: SEARCH_SORT_ORDER.desc,
  sortKey: 'relevance',
} as const

export const SEARCH_KEYBOARD = {
  escape: 'Escape',
} as const

export const SEARCH_SORT_OPTIONS = [
  {
    key: 'relevance',
    label: 'Relevance',
    sortBy: SEARCH_SORT_BY.relevance,
    sortOrder: SEARCH_SORT_ORDER.desc,
  },
  {
    key: 'price-asc',
    label: 'Price: Low to High',
    sortBy: SEARCH_SORT_BY.displayPrice,
    sortOrder: SEARCH_SORT_ORDER.asc,
  },
  {
    key: 'price-desc',
    label: 'Price: High to Low',
    sortBy: SEARCH_SORT_BY.displayPrice,
    sortOrder: SEARCH_SORT_ORDER.desc,
  },
  {
    key: 'newest',
    label: 'Newest',
    sortBy: SEARCH_SORT_BY.createdAt,
    sortOrder: SEARCH_SORT_ORDER.desc,
  },
  {
    key: 'name',
    label: 'Name A–Z',
    sortBy: SEARCH_SORT_BY.name,
    sortOrder: SEARCH_SORT_ORDER.asc,
  },
] as const

export type SearchSortOptionKey = (typeof SEARCH_SORT_OPTIONS)[number]['key']

export const SEARCH_UI = {
  placeholder: 'Search flowers, plants, combos, occasions...',
  pageTitle: 'Search',
  homeCrumb: 'Home',
  sortLabel: 'Sort by',
  loadMore: 'Show more products',
  emptyQueryTitle: 'Search our collection',
  emptyQueryHint: 'Try flowers, plants, gifts, or occasions.',
  emptyResults: 'No products matched your search.',
  errorFallback: 'Failed to search products',
  submitAria: 'Search',
  suggestionsLabel: 'Product suggestions',
  searching: 'Searching…',
  viewAllResults: 'View all results',
  resultsFor: (query: string) => `Results for “${query}”`,
  resultCount: (total: number) =>
    total === 1 ? '1 product' : `${total} products`,
} as const
